module.exports = __webpack_public_path__ + "static/detecht-footerBanner-min-a13219fc52f33db6e4849b3756c702c1.jpg";